import svg from './row-svg/cross-v3.svg';

import { FixMe } from '@greenkub-fronts/shared/interface';

export function CrossV3Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default CrossV3Icon;
